export default "__VITE_ASSET__C2A_gPWT__"